module.exports = __webpack_public_path__ + "img/image.80eb4d24.png";